import Marquee from "react-fast-marquee";

const items = ["FINTECH", "ARTIFICIAL INTELLIGENCE", "ROBOTICS", "MACHINE LEARNING"];

export const Ribbon = () => {
  return (
    <section
      data-testid="marquee"
      className="relative z-10 py-10 border-y border-white/10 bg-gradient-to-r from-[#0A0A0C] via-[#1A0B2E] to-[#0D0B14] overflow-hidden"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((it, i) => (
          <span key={`${it}-${i}`} className="flex items-center">
            <span className="font-future text-3xl sm:text-5xl lg:text-6xl font-light tracking-tight text-white/80 mx-8">
              {it}
            </span>
            <span className="text-[var(--neon-magenta)] text-3xl sm:text-5xl lg:text-6xl">·</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
